import React from 'react';

import { FilerTranslateItem } from '.';
import FilterResultItem from './FilterResultItem';
import {
  replaceAllComplex,
  splitNumberThousands,
} from '../../../../../../mol_function';
import { SearchPageSortParams } from '../../Route';



interface FilterResultProp {
  queryParams: any;
  filterTranslate: FilerTranslateItem[];

  filterData: any;
  totalItems: number;
  showTopBorder: boolean;
  searchHasError: boolean;
}

export default class FilterResult extends React.Component<FilterResultProp> {
  render() {
    let filterArray: FilerTranslateItem[] | null = null;

    try {
      filterArray = JSON.parse(JSON.stringify(this.props.filterTranslate));
    } catch {}

    if (filterArray == undefined || filterArray == null) {
      filterArray = [];
    }

    let queryKeys = Object.keys(this.props.queryParams);

    if (
      queryKeys.indexOf('keyword') != -1 &&
      this.props.queryParams['keyword'] != '*'
    ) {
      filterArray.push({
        caption: 'Suchbegriff',
        field: 'keyword',
        fieldPrefix: '',
        prio: 99,
      });
    }

    for (let i = 0; i < queryKeys.length; i++) {
      let found = false;
      if (queryKeys[i] == 'keyword' && this.props.queryParams['keyword'] == '*')
        found = true;

      for (let j = 0; !found && j < filterArray.length; j++) {
        let prefixKey: string = 'fqZZZ';
        let tmpPrefix = filterArray[j].fieldPrefix;

        if (tmpPrefix != undefined) {
          prefixKey = tmpPrefix;
        }

        let currentKey = prefixKey + filterArray[j].field;
        if (currentKey == queryKeys[i]) {
          found = true;
        }
      }
      if (!found) {
        if (queryKeys[i].startsWith('fqZZZ')) {
          let keypart = queryKeys[i].substring(5);
          filterArray.push({
            caption: replaceAllComplex(keypart, [{ s: '_', r: ' ' }]),
            field: keypart,
            fieldPrefix: undefined,
            prio: -1,
          });
        }
      }
    }

    let className = '';
    if (this.props.showTopBorder) className = 'topBorder';

    let totalItemsText = '0';
    if (this.props.totalItems != null) {
      totalItemsText = splitNumberThousands(this.props.totalItems);
    }

    return (
      <div id="FilterResult" className={className}>
        {this.props.searchHasError == false ? (
          <div className="FilterResultItem">
            Ergebnis: {totalItemsText} Artikel
          </div>
        ) : null}

        {filterArray.map((item, index) => {
          let filterPrefix = 'fqZZZ';
          if (item.fieldPrefix != undefined) {
            filterPrefix = item.fieldPrefix;
          }

          let queryKey = filterPrefix + item.field;
          let index_qk = queryKeys.indexOf(queryKey);
          if (index_qk > -1) {
            let parts = this.props.queryParams[queryKey];
            let partArray: string[] = parts.split('|');
            return partArray.map((item2, index2) => {
              if (item.mode == 'radio') {
                let values = this.props.filterData[item.field];

                let valuesKeys = Object.keys(values);
                let found = false;
                for (let i = 0; !found && i < valuesKeys.length; i++) {
                  if (values[valuesKeys[i]].key == item2) {
                    found = true;
                    item2 = valuesKeys[i];
                  }
                }
              } else if (item.mode == 'custom' && item.custom_id != undefined) {
                item2 = item.custom_id.toString();
              }

              if (
                item.mode != 'custom' ||
                (item.mode == 'custom' && index2 == 0)
              )
                return (
                  <FilterResultItem
                    key={'FilterResultItem' + index + '_' + index2}
                    item={item}
                    value={item2}
                    delAction={(
                      item: FilerTranslateItem,
                      value: string,
                      historyHandle: any,
                    ) => this.delActionHandle(item, value, historyHandle)}
                  ></FilterResultItem>
                );
            });
          }
        })}
      </div>
    );
  }

  delActionHandle(item: FilerTranslateItem, value: string, historyHandle: any) {
    let queryParams = this.props.queryParams;
    let prefix = 'fqZZZ';
    if (item.fieldPrefix != undefined) {
      prefix = item.fieldPrefix;
    }
    if (item.mode == 'radio') {
      delete queryParams[prefix + item.field];
    } else {
      let paramsArray = queryParams[prefix + item.field].split('|');
      let index = -1;

      for (let j = 0; index == -1 && j < paramsArray.length; j++) {
        if (paramsArray[j] == value) index = j;
      }

      let newArray = [];

      for (let i = 0; i < paramsArray.length; i++) {
        if (i != index) newArray.push(paramsArray[i]);
      }

      if (newArray.length == 0) {
        delete queryParams[prefix + item.field];
      } else {
        queryParams[prefix + item.field] = newArray.join('|');
      }
    }

    delete queryParams['page'];

    let newQueryString = '';

    let newQueryStringArray: string[] = [];

    let keys = Object.keys(queryParams);
    for (let i = 0; i < keys.length; i++) {
      let value = decodeURIComponent(
        replaceAllComplex(queryParams[keys[i]], [{ s: '%2F', r: '___' }]),
      );

      newQueryStringArray.push(keys[i] + '=' + encodeURIComponent(value));
    }

    newQueryString = '?' + SearchPageSortParams(newQueryStringArray);

    historyHandle.push('/search_page/' + newQueryString);
  }
}
